__turbopack_context__.v({
  "actionInfoPromo": "PromotionSummary-module-scss-module__aeTgoq__actionInfoPromo",
  "code": "PromotionSummary-module-scss-module__aeTgoq__code",
  "item": "PromotionSummary-module-scss-module__aeTgoq__item",
  "promotionSummary": "PromotionSummary-module-scss-module__aeTgoq__promotionSummary",
});
